import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';

import { RouterService } from './core/router.sevice';
import { ApiService } from './core/api.service';

import { AccountService } from './app/account.service';
import { CommerceService } from './app/commerce.service';
import { CatalogueService } from './core/cataloque.service';
import { BuroService } from './app/buro.service';
import { FinanceService } from './app/finance.service';
import { ValidatorService } from './app/validator.service';
import { loadingService } from './loading.service';



@NgModule({
  imports: [
    HttpModule
  ],
  providers: [
    RouterService,
    ApiService,
    CatalogueService,
    AccountService,
    loadingService,
    CommerceService,
    BuroService,
    FinanceService,
    ValidatorService,
  ]
})
export class AppServiceModule { }



// WEBPACK FOOTER //
// ./src/app/core/service/app-service.module.ts